import '../node_modules/bootstrap/scss/bootstrap.scss' 


// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

function App() {
  return (
    <div className="App container-fluid g-0 fullvh">

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-2">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white mb-5 t-76 title-shade">Arquitectónicos y Sostenibilidad</h3>    
                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/arquitectonicos/fullcolor" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Fullcolor <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/arquitectonicos/artepolisvisto" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Artépolis visto <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/arquitectonicos/artepoliscantorodado" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Artépolis canto rodado <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/arquitectonicos/Decomix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Decomix  <span className="chevron">></span></p>
                      </div>
                      </Link>
                      
                    </div>                    

                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <Link to="/productos/arquitectonicos/termomuro" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Termomuro  <span className="chevron">></span></p>
                      </div>
                      </Link>                    

                      <Link to="/productos/arquitectonicos/lowmix" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Lowmix <span className="chevron">></span></p>
                      </div>
                      </Link>

                      <Link to="/productos/arquitectonicos/mix3d" relative="path">
                      <div className="product-block-vivienda d-flex flex-column">
                        <p className="product-block-vivienda-text text-center">Mix3d <span className="chevron">></span></p>
                      </div>
                      </Link>

                      
                    </div>                    

                  </div>                  

                </div>
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
